import type { EmailIntegration } from "@/schema"
import { useQuery, type UseQueryOptions } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchBookEmailIntegrations, fetchEmailIntegration, fetchEmailIntegrations } from "./api"

interface EmailIntegrationsOptions {
  refetchInterval?: UseQueryOptions<EmailIntegration[]>["refetchInterval"]
}

export function useEmailIntegrations(options?: EmailIntegrationsOptions) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["email_integrations"],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchEmailIntegrations(context)
    },
    refetchInterval: options?.refetchInterval,
  })
}

export function useBookEmailIntegrations(bookId: string, options?: { enabled?: boolean }) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["book_email_integrations", bookId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchBookEmailIntegrations(context, bookId)
    },
    enabled: options?.enabled ?? true,
  })
}

export function useEmailIntegration(id: string) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["email_integrations", id],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchEmailIntegration(context, id)
    },
  })
}
